import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerOverlay,
  DrawerContent,
  useDisclosure,
  Flex,
  Text,
  Icon,
  Table,
  Thead,
  Tbody,
  Spinner,
} from '@chakra-ui/react'
import React from 'react'
import { AiFillPlusCircle, AiOutlineArrowLeft } from 'react-icons/ai'
import { Columns } from './Columns'
import { List } from './List'
import { Button } from '../../../../../../components/Button'
import { useQuery } from 'react-query'
import { api } from '../../../../../../services/api'
import { format } from 'date-fns'
import { formatPrice } from '../../../../../../utils/formatPrice'
//https://api.innovationbrindes.com.br/api/site/v2/orcamento-crm/listar-dados-orcamento-parceiro/codigo_parceiro

async function getListaOrcamento({ codParc }) {
  const response = await api.get(`/site/v2/orcamento-crm/listar-dados-orcamento-parceiro/${codParc}`)

  const infoColor = {
    'EM NEGOCIAÇÃO': '#9370DB',
    'EM ANÁLISE PARA FECHAMENTO': '#00CBFF',
    'LAYOUT ENCAMINHADO': '#8FA197',
    'CHAMADO NOVO': '#95C620',
    'FEEDBACK DA PROPOSTA': '#FFA07A',
    'PRIMEIRO CONTATO': '#FF9900',
    'VENDA CONVERTIDA (PEDIDO)': '#20B2AA',
    PERDIDO: '#F11900',
    'AGUARDANDO APROVAÇÃO CLIENTE': '#378BBF',
    'AGUARDANDO PAGAMENTO': '#A7A7A7',
    'EM APROVAÇÃO': '#FFD700',
  }

  return response.data.map((item) => {
    return {
      ...item,
      abertura: item.data_abertura,
      valorProposta: item.valor_proposta ? formatPrice(item.valor_proposta) : '',
      dataPropostaEncaminhada: item.data_proposta_encaminhada
        ? format(new Date(item.data_proposta_encaminhada), 'dd/MM/yyyy HH:mm')
        : 'Não encaminhada',
      lineColor: infoColor[item.funil_vendas],
      ultimoContato: item.dt_ultimo_contato ? format(new Date(item.dt_ultimo_contato), 'dd/MM/yyyy HH:mm') : '',
      retornarEm: item.dt_retorno ? format(new Date(item.dt_retorno), 'dd/MM/yyyy HH:mm') : '',
      funilVendas: item.funil_vendas?.toLowerCase() || '',
      info_itens:
        item?.info_itens &&
        item?.info_itens?.map((item) => {
          return {
            ...item,
            codigo_produto: item.codigo_produto,
            cor: item.cor,
            quantidade_itens: new Intl.NumberFormat('pt-BR').format(item.quantidade_itens),
          }
        }),
      info_layout:
        item.info_layout &&
        item.info_layout.map((item) => {
          return {
            ...item,
            link_layout: item.link_layout,
            codigo_produto: item.codigo_produto,
            cor: item.cor,
            solicitacao: item.solicitacao
              ? //dd/MM/yyyy às HH:mm
                format(new Date(item.solicitacao), "dd/MM/yyyy '/' HH:mm")
              : '',
            encaminhado: item.encaminhado ? format(new Date(item.encaminhado), "dd/MM/yyyy '/' HH:mm") : '',
            nome_usuario: item.nome_usuario ? item.nome_usuario : '',
          }
        }),
    }
  })
}

export function TotalOrcamentos({ totalOrcamentos, infoProposta }) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const btnRef = React.useRef()

  const { data: listaOrcamento = [], isLoading } = useQuery({
    queryKey: ['listOrcamento'],
    queryFn: () => getListaOrcamento({ codParc: infoProposta?.cliente.codigo_parceiro }),
    enabled: isOpen,
  })

  return (
    <>
      <Flex justifyContent="space-between" alignItems="center" onClick={onOpen} cursor="pointer" pointerEvents={'auto'}>
        <Text>
          Orçamentos: <strong>{totalOrcamentos}</strong>
        </Text>
        <Icon as={AiFillPlusCircle} color="#378BBF" fontSize="20px" />
      </Flex>

      <Drawer isOpen={isOpen} placement="bottom" onClose={onClose} finalFocusRef={btnRef}>
        <DrawerOverlay />
        <DrawerContent minH="100vh">
          <Text bgColor="#378BBF" textAlign="center" color="#F5F5F5" textTransform="uppercase" py="14px" fontWeight="semibold">
            TOTAL DE ORÇAMENTOS: <strong>{totalOrcamentos}</strong>
          </Text>

          <DrawerBody>
            <Table mt={4} borderCollapse="collapse" variant="outline">
              <Thead>
                <Columns />
              </Thead>
              <Tbody>
                {isLoading && (
                  <Flex
                    position="fixed"
                    zIndex="9999"
                    //transparente, com blur e no centro da tela
                    bg="rgba(255, 255, 255, 0.5)"
                    w="100%"
                    h="100%"
                    justifyContent="center"
                    alignItems="center"
                    backdropFilter="blur(5px)"
                    flexDirection="column"
                    gap={2}
                  >
                    <Text fontSize="20px" color="blue.500" fontWeight="bold" textAlign="center">
                      Carregando informações de orçamento...
                    </Text>
                    <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="blue.500" size="xl" />
                  </Flex>
                )}
                <List data={listaOrcamento} infoLigacoes={infoProposta?.info_ligacoes} />
              </Tbody>
            </Table>
          </DrawerBody>

          <DrawerFooter position="sticky" mt="auto" bottom="0" boxShadow="0px 3px 6px rgba(0, 0, 0, 0.635)">
            <Flex alignItems="center" justifyContent="end" w="100%">
              <Button
                maxW="181px"
                w="100%"
                fontSize="15px"
                fontWeight="semibold"
                bgColor="transparent"
                color="#FFA200"
                border="1px solid #FFA200"
                onClick={onClose}
              >
                <AiOutlineArrowLeft style={{ marginRight: '5px' }} />
                Voltar
              </Button>
            </Flex>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  )
}
